import httpClient from '@/http-client'

export const getCalculationMenuData = data => {
  return httpClient
    .get('/api/calculation-menus/data', data)
    .then(response => Promise.resolve(response.data))
    .catch(error =>
      Promise.reject(error.response ? error.response.data : error)
    )
}

export const exportCalculationMenuExcel = data => {
  return httpClient
    .post('/api/calculation-menus/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error =>
      Promise.reject(error.response ? error.response.data : error)
    )
}

export const saveCalculationMenuManual = data => {
  return httpClient
    .post('/api/calculation-menus/save-manual', data)
    .then(response => Promise.resolve(response.data))
    .catch(error =>
      Promise.reject(error.response ? error.response.data : error)
    )
}

export const calculateHeadcount = data => {
  return httpClient
    .post('/api/calculation-menus/calculate', data)
    .then(response => Promise.resolve(response.data))
    .catch(error =>
      Promise.reject(error.response ? error.response.data : error)
    )
}

export default {
  getCalculationMenuData,
  exportCalculationMenuExcel,
  saveCalculationMenuManual,
  calculateHeadcount
}
